import { createElementBlock as l, openBlock as r, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(d, e) {
  return r(), l("svg", n, e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.401 4.123a8.003 8.003 0 0 0-5.926 14.478 1 1 0 0 1-1.132 1.65 10.002 10.002 0 0 1 7.408-18.097 1 1 0 0 1-.35 1.97m2.677-.206a1 1 0 0 1 1.384-.29 10 10 0 0 1 4.065 5.367l2.27-.473a1 1 0 0 1 .408 1.958l-2.271.473a10 10 0 0 1-11.876 10.86 1 1 0 1 1 .385-1.962 8.003 8.003 0 0 0 9.52-8.487L11.3 12.75a1.5 1.5 0 1 1-.409-1.958l6.666-1.388a8 8 0 0 0-3.19-4.104 1 1 0 0 1-.29-1.384",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const c = { render: t };
export {
  c as default,
  t as render
};
//# sourceMappingURL=ic_radar_scheduled-CZyDAA1U.js.map
